import React, { Component } from 'react';
import { connect } from 'dva';
import { Steps } from 'antd';
import { modelUtils } from '@/utils';
import { utils_tool, component_tool, framework_tool } from '@/tool';
let { Session, Storage } = utils_tool;
import { WizTableForm, WizDataAuthSelect } from '@/containers/common'
import * as local_urls from '../../../constants/constants_url';
const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;
const workflowProcDef = WizTableForm.Config.workflowProcDef(this, { apiParams: { state: 1 } })
let { WizButton, WizCard, WizAntdForm, WizCustomSteps, WizRow, WizCol, WizLayout, WizIcon, WizSpin, WizForm } = component_tool;
import { Row, Col, Form, Spin } from "antd";
import WorkflowAuthSelectDetail from './workflowAuthSelectDetail'
let { WizContainer } = framework_tool;
const { Step } = Steps;
const getParamRecord = (history) => {
    let record = [];
    if (history.location) {
        if (history.location.pathname === '/workflow/workflowAuditDetail') {
            if (history.location && history.location.record) {
                record = history.location.record;
                Session.set('workflowAudit', record)
            } else {
                record = Session.get('workflowAudit') || 0
            }
        }
    } else {
        record = Session.get('workflowAudit') || 0
    }
    return record
};
class WorkflowAuditDetail extends WizContainer {

    componentName = 'workflowAuditDetail';

    constructor(props) {
        super(props);
        let record = getParamRecord(this.props.history);
        this.nextStepState = false;
        this.state = {
            initialValue: {
                orgIds: [],
                positionIds: [],
                positionCategoryIds: [],
                personIds: [],
                methodCodes: [],
            },
            authInfo: {
                orgIds: [],
                positionIds: [],
                positionCategoryIds: [],
                personIds: [],
            },
            record: record,
            auditId: record['id'] || null,
            current: 0,
            stepCurrent: 0,
            list: [],
        }
    }

    propsAndStateOnChange = {
        nodeList: this._nodeList.bind(this),
        getNodeAuth: this._getNodeAuth.bind(this),
        authInfo: this._authInfo.bind(this),
        saveAudit: this._saveAudit.bind(this),
        saveAuth: this._saveAuth.bind(this),
        saveNodeAuth: this._saveNodeAuth.bind(this),
    };

    _nodeList(nextProps, nextState) {
        let { nodeList } = nextProps;
        if (nodeList && nodeList['success']) {
            let list = nodeList['data'];
            let nodeId;
            if (list.length > 0) {
                nodeId = list[nextState['current']].nodeId;
            }
            nextState.list = nodeList['data']

            nextState.nodeId = nodeId
            this.doActions([
                {
                    path: 'node/getAuth',
                    payload: {
                        key: 'getNodeAuth',
                        apiParams: {
                            nodeId: nodeId,
                            auditId: this.state.auditId,
                        }
                    }
                },
            ]);
        } else {
            this.nextStepState = false;
            WizNotice.error('保存失败：' + nodeList.msg);
        }
        return true
    }

    _componentDidMount() {
    }
    _authInfo(nextProps, nextState) {
        let { authInfo } = nextProps;
        if (authInfo && authInfo['success']) {
            nextState.authInfo = authInfo['data']
        }
        return true
    }
    _saveNodeAuth(nextProps, nextState) {
        let { saveNodeAuth } = nextProps;
        if (saveNodeAuth && saveNodeAuth['success']) {
            if (this.nextStepState) {
                this.nextStepState = false;
                nextState.stepCurrent = this.state.stepCurrent + 1;
            } else {
                this.jumpPage('replace', '/workflow/workflowAudit');
            }
            nextState.saveNodeAuth = saveNodeAuth['data']
        }
        return true
    }
    _saveAudit(nextProps, nextState) {
        let { saveAudit } = nextProps;
        if (saveAudit && saveAudit['success']) {

            if (this.nextStepState) {
                this.nextStepState = false;
                nextState.stepCurrent = this.state.stepCurrent + 1;
            } else {

                this.jumpPage('replace', '/workflow/workflowAudit');
            }
            nextState.auditId = saveAudit['data']
        }
        return true
    }
    _saveAuth(nextProps, nextState) {
        let { saveAuth } = nextProps;
        if (saveAuth && saveAuth['success']) {
            this.jumpPage('replace', '/workflow/workflowAudit');
        }
        return true
    }
    _getNodeAuth(nextProps, nextState) {
        let { getNodeAuth } = nextProps;
        if (getNodeAuth && getNodeAuth['success']) {
            nextState['initialValue'] = getNodeAuth['data']
        }
        return true
    }


    _saveAuditInfo(values) {
        //let fitterValues = this.fitterFieldsValue(values)
        this.doActions([
            {
                path: 'workflowAudit/saveAudit',
                payload: {
                    key: 'saveAudit',
                    apiParams: {
                        ...values, id: this.state.auditId
                    }
                }
            },
        ]);
    }

    previousStep() {

        const { stepCurrent } = this.state;
        this.setState({ stepCurrent: stepCurrent - 1 });
    }
    nextStep(stepCount) {

        const { record, auditId } = this.state;
        this.nextStepState = true
        if (stepCount === 1) {
            this.doActions([
                {
                    path: 'node/list',
                    payload: {
                        key: 'nodeList',
                        apiParams: {
                            procDefId: record['procDefId']
                        }
                    }
                },
            ]);
        }
        if (stepCount === 2) {
            this.doActions([
                {
                    path: 'workflowAudit/authInfo',
                    payload: {
                        key: 'authInfo',
                        apiParams: {
                            id: auditId
                        }
                    }
                },
            ]);
            //this.setState({stepCurrent:this.state.stepCurrent +1})
        }
        // this.setState({stepCurrent:this.state.stepCurrent +1})
    }

    _onReset = () => {

        let ref = this.refs.form
        if (ref) {
            ref.resetFields()
        }
    }
    onChange = current => {

        const { list, auditId } = this.state;
        let nodeId;
        if (list.length > 0) {
            nodeId = list[current].nodeId;
        }
        this.doActions([
            {
                path: 'node/getAuth',
                payload: {
                    key: 'getNodeAuth',
                    apiParams: {
                        nodeId: nodeId,
                        auditId: auditId,
                    }
                }
            },
        ]);

        this.setState({ current, nodeId });
    };
    /**表单底部按钮 */
    formFooter = () => {
        return (
            <WizRow className="form-btns row-item">
                <WizCol span={24}>
                    <WizButton title='保存并进入下一步' type='primary' htmlType='submit'
                        onClick={e => this.nextStep(1)}>保存并进入下一步</WizButton>
                    <WizButton title='保存并返回' htmlType='submit'>保存并返回</WizButton>
                    <WizButton title='重置' type='reset' onClick={e => this._onReset()}>重置</WizButton>
                </WizCol>
            </WizRow>
        )
    }
    _columns() {
        let { record } = this.state
        let procDefId = []
        let initRows = []
        let initialValue = []
        if (record) {
            initialValue.push(record['procDefId'])
            initRows.push({ id: record['procDefId'], name: record['procDefName'] })
        }
        return [
            {
                title: '流程名称',
                name: 'name',
                formItem: {
                    maxlength: 50,
                    rules: [{ required: true, message: '请输入流程名称' }]
                }
            },
            {
                title: "流程说明",
                name: "intro",
                dataIndex: "intro",
                formItem: {
                    type: 'textarea',
                    placeholder: '请输入流程说明,最多500字',
                    maxlength: 100,
                },
            },
            {
                title: '流程类型',
                name: 'auditType',
                dict: [
                    { code: 'ApplyCommon', codeName: "公共报名" },
                    { code: 'ApplyClass', codeName: "班级报名" },
                    { code: '2', codeName: "考试报名" },
                    { code: '3', codeName: "直播报名" },
                    { code: 'ApplyActivities', codeName: "活动报名" },
                    { code: '5', codeName: "投票报名" },
                    { code: '6', codeName: "其他报名" }
                ],
                formItem: {
                    type: 'select',
                    initialValue: record.type && record.type != 0 ? record.type : null,
                    rules: [{
                        required: true,
                        message: '请选择'
                    }]
                }
            },
            {
                title: '选择流程',
                name: 'procDefId',
                formItem: {
                    ...workflowProcDef,
                    diy: WizTableForm,
                    initialValue,
                    initRows,
                    type: 'diy',
                    links: { 'auditType': '流程类型' },
                    linksKeyFormat: { 'auditType': 'type' },
                    selectType: 'radio',
                    rules: [{
                        required: true,
                        message: '请选择流程',
                    }]
                }
            },
            {
                title: "状态",
                name: "state",
                dataIndex: "state",
                tableItem: {},
                dict: [
                    { code: 1, codeName: "激活" },
                    { code: 0, codeName: "禁用" }
                ],
                formItem: {
                    type: "select",
                    initialValue: record.state && record.state != 0 ? record.state : 1,
                    rules: [{
                        required: true,
                        message: '请选择'
                    }]
                }
            }
        ]

    }

    stepView() {

        const { current, stepCurrent, nodeId, list, initialValue, authInfo, record } = this.state;
        let columns = this._columns()
        let onSubmit = this._saveAuditInfo.bind(this);
        let formProps = {
            ref: 'form',
            columns,
            onSubmit,
            record: record,
            preview: null,
            footer: this.formFooter(),
            formItemLayout: {
                labelCol: { span: 6 },
                wrapperCol: { span: 12 }//15
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        let img = `/api${urls.kUrlViewProcedefResource}?id=${record.procDefId}&deploymentId=${record.deploymentId}&dgrmResourceName=${record.dgrmResourceName}&access-token=${Storage.getStorage("token")}`;

        const selectProps = {
            key: this.state.nodeId,
            initialValue: initialValue,
            prev: this.previousStep.bind(this),
            next: this.nextStep.bind(this, 2),
            submit: (value) => {
                let saveRequest = {};
                if (value['dataAuth']) {
                    let dataAuth = value['dataAuth'];
                    // saveRequest['positionIds'] = dataAuth['positionIds'].map(p => (p.id));
                    // saveRequest['personIds'] = dataAuth['personIds'].map(p => (p['personId']))
                    // saveRequest['orgIds'] = dataAuth['orgIds'].map(p => (p['id']))
                    // saveRequest['positionCategoryIds'] = dataAuth['positionCategoryIds'].map(p => (p['id']))
                    if(dataAuth["groupId"] && dataAuth["groupId"].length) {
                        saveRequest["groupId"] = dataAuth["groupId"].map((p) => p["id"]).toString();
                    } else {
                        saveRequest["orgIds"] = dataAuth["orgIds"] && dataAuth["orgIds"].map((p) => p["id"]);
                        saveRequest["positionIds"] = dataAuth["positionIds"] && dataAuth["positionIds"].map((p) => p["id"]);
                        saveRequest["positionCategoryIds"] = dataAuth["positionCategoryIds"] && dataAuth["positionCategoryIds"].map((p) => p["id"]);
                        saveRequest["personIds"] = dataAuth["personIds"] && dataAuth["personIds"].map((p) => p["id"]);
                    }
                    saveRequest['methodIds'] = dataAuth['methodIds'].map(p => (p['id']))
                }
                saveRequest['auditId'] = this.state.auditId;
                saveRequest['nodeId'] = this.state.nodeId;

                this.doAction({
                    path: 'node/saveAuth',
                    payload: {
                        key: "saveNodeAuth",
                        apiParams: {
                            ...saveRequest
                        }
                    }
                });
            },
        };

        const scopeSelectProps = {
            key: this.state.nodeId,
            initialValue: authInfo,
            prev: this.previousStep.bind(this),
            submit: (value) => {
                let saveRequest = {};
                if (value['dataAuth']) {
                    let dataAuth = value['dataAuth'];
                    // saveRequest['positionIds'] = dataAuth['positionIds'].map(p => (p.id));
                    // saveRequest['personIds'] = dataAuth['personIds'].map(p => (p['personId']))
                    // saveRequest['orgIds'] = dataAuth['orgIds'].map(p => (p['id']))
                    // saveRequest['positionCategoryIds'] = dataAuth['positionCategoryIds'].map(p => (p['id']))

                    if(dataAuth["groupId"] && dataAuth["groupId"].length) {
                        saveRequest["groupId"] = dataAuth["groupId"].map((p) => p["id"]).toString();
                    } else {
                        saveRequest["orgIds"] = dataAuth["orgIds"] && dataAuth["orgIds"].map((p) => p["id"]);
                        saveRequest["positionIds"] = dataAuth["positionIds"] && dataAuth["positionIds"].map((p) => p["id"]);
                        saveRequest["positionCategoryIds"] = dataAuth["positionCategoryIds"] && dataAuth["positionCategoryIds"].map((p) => p["id"]);
                        saveRequest["personIds"] = dataAuth["personIds"] && dataAuth["personIds"].map((p) => p["id"]);
                    }
                }
                saveRequest['id'] = this.state.auditId;

                this.doAction({
                    path: 'workflowAudit/saveAuth',
                    payload: {
                        key: "saveAuth",
                        apiParams: {
                            ...saveRequest
                        }
                    }
                });
            },
        };
        switch (this.state.stepCurrent) {
            case 0:
                return <>
                    <WizForm {...formProps} /></>
                break;
            case 1:
                return <>

                    <WizRow >
                        <WizCol span={4}>
                            <Steps current={current} onChange={this.onChange} direction="vertical">
                                {
                                    list.map((val, index) => (
                                        <Step title={val.name} />
                                    ))
                                }
                            </Steps>
                        </WizCol>
                        <WizCol span={20} justify="start">
                            <img src={img} />
                        </WizCol>
                    </WizRow>
                    <WizRow justify="start">
                        <WorkflowAuthSelectDetail {...selectProps} />
                    </WizRow>
                </>

                break;

            case 2:
            default:
                return <>
                    <WizRow justify="start">
                        <WorkflowAuthSelectDetail {...scopeSelectProps} />
                    </WizRow>
                </>
                break;
        }
    }
    _render() {

        const { current, stepCurrent, nodeId, list, initialValue, auditId } = this.state;
        const { nodeLoading, workflowAuditLoading } = this.props


        const wizCustomStepsProps = {
            header: [
                {
                    title: '审核基本信息',
                },
                {
                    title: '审核人员设置',
                },
                {
                    title: '权限受众设置',
                }
            ],
            current: stepCurrent,
            content: this.stepView(),
            footer: null
        }
        return (

            <WizCard>

                <React.Fragment>
                    <WizSpin tip={'加载中'} spinning={nodeLoading && workflowAuditLoading}>
                        <WizCustomSteps {...wizCustomStepsProps} />
                    </WizSpin>
                </React.Fragment>
            </WizCard>
        )

    }
}

const mapStateToProps = (state, ownProps) => {

    const { node, workflowAudit } = state;

    const nodeList = modelUtils.getModelEntity(node, "nodeList");
    const saveAudit = modelUtils.getModelEntity(workflowAudit, "saveAudit");
    const authInfo = modelUtils.getModelEntity(workflowAudit, "authInfo");
    const saveNodeAuth = modelUtils.getModelEntity(node, "saveNodeAuth");
    const saveAuth = modelUtils.getModelEntity(workflowAudit, "saveAuth");
    const getNodeAuth = modelUtils.getModelEntity(node, "getNodeAuth");

    const load = modelUtils.getLoadingState(state, ['node']);
    return {
        nodeList,
        saveNodeAuth,
        saveAuth,
        saveAudit,
        authInfo,
        getNodeAuth,
        ...load
    }
};

export default connect(mapStateToProps)(WorkflowAuditDetail)
